import { useEffect, useRef } from "react"

/**
 * Custom React hook that logs the differences in props between renders.
 * Useful for debugging why a component re-renders.
 *
 * @param componentName - Name of the component using this hook (for logging purposes)
 * @param props - The current props passed to the component
 */

export function useWhyDidYouUpdate(componentName: string, props: Record<string, any>) {
    const previousProps = useRef(props)
    const renderCount = useRef(1)

    useEffect(() => {
        const allKeys = Object.keys({ ...previousProps.current, ...props })
        const changesObj: Record<string, { from: any; to: any }> = {}

        allKeys.forEach((key) => {
            if (previousProps.current[key] !== props[key]) {
                changesObj[key] = {
                    from: previousProps.current[key],
                    to: props[key],
                }
            }
        })

        renderCount.current += 1

        if (Object.keys(changesObj).length > 0) {
            console.log(`[why-did-you-update] <${componentName}> (render #${renderCount.current - 1})`, changesObj)
        } else {
            console.log(`[why-did-you-update] <${componentName}> (render #${renderCount.current - 1}) - no prop changes`)
        }

        previousProps.current = props
    }, [props])
}
